import getRequestUrl from "./getRequestUrl";
import getConfiguredRequest from "./getConfiguredRequest";
import handleRequestError from "./handleRequestError";

const RECS_SCOPE_VALUE = "saveditems_seesimilar";
const RECS_REQUEST_ID_HEADER = "asos-s-recs-request-id";

export default async ({ productId, authorisationHeader, retryCallback }) => {
  const requestUrl = getRequestUrl({ productId });
  const request = getConfiguredRequest({ retryCallback });
  const headers = {
    Authorization: authorisationHeader,
    "asos-c-recs-scope": RECS_SCOPE_VALUE
  };

  try {
    const { data, headers: responseHeaders } = await request.get({
      url: requestUrl,
      headers
    });

    return {
      ...data,
      recommendationsRequestId: responseHeaders?.[RECS_REQUEST_ID_HEADER]
    };
  } catch (e) {
    return handleRequestError({ error: e });
  }
};
